import * as React from 'react'
import Checkbox from '../Checkbox'

interface TableCheckboxHeaderProps {
  toggleAll: (checked: boolean, isActive: boolean) => void
  isSelectedAny: boolean
  disabled: boolean
  transparent?: boolean
}

const TableCheckboxHeader = ({
  toggleAll,
  isSelectedAny,
  disabled,
  transparent = false,
}: TableCheckboxHeaderProps) => {
  return (
    <th
      className={`${!disabled && 'stickyChild'} notches-border--left tw-w-4 ${transparent ? 'tw-bg-transparent' : 'tw-bg-content-primary'} tw-pb-1.5 tw-pl-2 tw-pr-2 tw-pt-2.5`}
    >
      <label
        className={`tw-inline-flex tw-items-center ${disabled && 'tw-invisible tw-bg-content-primary'}`}
      >
        <Checkbox
          onChange={(e: any) => toggleAll(e, true)}
          disabled={disabled}
          checked={isSelectedAny}
          type={'dot'}
        />
      </label>
    </th>
  )
}

export default TableCheckboxHeader
